function getSelectedBundlePrice() {
  const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
  if (!checkedInput) return null;
  const label = document.querySelector(`label[for="${checkedInput.id}"]`);
  if (!label) return null;
  const priceEl = label.querySelector('.bundlenewprice');
  if (!priceEl) return null;
  const raw = priceEl.textContent.trim();
  const cleaned = raw.replace(/[^\d.,]/g, '');
  const lastDot = cleaned.lastIndexOf('.');
  const lastComma = cleaned.lastIndexOf(',');
  const decimalIndex = Math.max(lastDot, lastComma);

  let normalized;
  if (decimalIndex === -1) {
    normalized = cleaned;
  } else {
    const integerPart = cleaned.slice(0, decimalIndex).replace(/[.,]/g, '');
    const decimalPart = cleaned.slice(decimalIndex + 1);
    normalized = integerPart + '.' + decimalPart;
  }
  const num = parseFloat(normalized);
  return isNaN(num) ? null : num;
}
function updateDiscountedPrice() {
  const bundlePrice = getSelectedBundlePrice();
  if (bundlePrice === null) return;
  const discountPercentage = 15;
  const discounted = bundlePrice * (100 - discountPercentage) / 100;
  const formatted = discounted.toFixed(2) + ' ₪';
  document.querySelectorAll('[data-discounted-price-input]').forEach((input) => {
    input.value = formatted;
  });
}
document.addEventListener('change', (event) => {
  if (event.target.matches('variant-selects input[type="radio"]')) {
    updateDiscountedPrice();
  }
});
document.addEventListener('variant:change', updateDiscountedPrice);
document.addEventListener('DOMContentLoaded', updateDiscountedPrice);